module.exports = "/_next/static/images/wallet-duotone-f0e1c18ad1203537cb1bb9cdbc53349a.svg";